import { AutocompleteValue } from '@mui/material';

export function transformOptionValue(option: string | { label: string; value: string }): string {
  return option !== null && typeof option === 'object' ? option.value : option;
}

export function transformOptions<
  A,
  B extends boolean | undefined,
  C extends boolean | undefined,
  D extends boolean | undefined
>(options: AutocompleteValue<A, B, C, D>, multiple: boolean = false) {
  if (multiple) {
    return Array.isArray(options) ? options.map(transformOptionValue) : [];
  }

  return transformOptionValue(options as { label: string; value: string } | string);
}
